import Skeleton from '@mui/material/Skeleton';

const DefaultSkeleton = (props) => {
    return (
        <Skeleton animation="wave" {...props} />
    )
}

export default DefaultSkeleton